import { useDispatch } from "react-redux";
import {
  approveRejectAction,
  getProviderProfileDetailAction,
} from "../../../redux/actions/ProviderProfileDetailAction";
import { getSnackbarSuccess } from "../../../Utils/helper";
import { GET_CURRENT_PAGE, GET_DURATION } from "../../../Utils/types";

export const initialFilterState = {
  page: 1,
  rows: 10,
  requestID: null,
  providerName: "",
  detailType: "",
  requestStatus: "",
  fromDate: "",
  toDate: "",
  SortDirection: "desc",
  sessionId: "",
  ticketId:"",
  providerId: "",
};

const rangeDatePicker = [
  {
    startDate: "Invalid date",
    endDate: "Invalid date",
    key: "selection",
  },
];

export function getApiParams({ globalReducer }) {
  let apiParams = {
    page: globalReducer?.getCurrentPage,
    fromDate:
      globalReducer?.getDuration[0]?.startDate === "Invalid date"
        ? null
        : globalReducer?.getDuration[0]?.startDate,
    toDate:
      globalReducer?.getDuration[0]?.endDate === "Invalid date"
        ? null
        : globalReducer?.getDuration[0]?.endDate,
  };
  return { apiParams };
}

export const clearDuration = (dispatch) => {
  dispatch({
    type: GET_DURATION,
    payload: rangeDatePicker,
  });
};

export const updateDurationDate = (dispatch, fromDate, toDate) => {
  dispatch({
    type: GET_DURATION,
    payload: [
      {
        startDate: fromDate,
        endDate: toDate,
        key: "selection",
      },
    ],
  });
};

export const clearCurrentPage = (dispatch) => {
  dispatch({
    type: GET_CURRENT_PAGE,
    payload: 1,
  });
};

const ApproveRejectHandler = async (
  type,
  rowData,
  setRowData,
  remark,
  searchFilter,
  apiParams,
  dispatch
) => {
  const temp = {
    RequestID: rowData?.requestID,
    Remarks: remark,
    RequestStatus: type,
    SessionID: rowData?.sessionID,
  };
  if (type === "REJECTED" && /^\s*$/.test(remark)) {
    getSnackbarSuccess(
      "info",
      "Please specify the reason for rejecting this request ?",
      dispatch
    );
  } else {
    await dispatch(approveRejectAction(temp));
    await dispatch(
      getProviderProfileDetailAction({ ...searchFilter, ...apiParams })
    );
    await setRowData(null);
  }
};

export const ApproveRejectButton = ({
  rowData,
  setRowData,
  remark,
  setRemark,
  searchFilter,
  apiParams,
}) => {
  const dispatch = useDispatch();
  return (
    <div className="d-flex justify-content-end flex-wrap gap-10">
      <button
        type="button"
        onClick={async () => {
          await ApproveRejectHandler(
            "APPROVED",
            rowData,
            setRowData,
            remark,
            searchFilter,
            apiParams,
            dispatch
          );
          await setRemark("");
        }}
        className="approve-btn"
      >
        Approve
      </button>
      <button
        type="button"
        onClick={async () => {
          await ApproveRejectHandler(
            "REJECTED",
            rowData,
            setRowData,
            remark,
            searchFilter,
            apiParams,
            dispatch
          );
          await setRemark("");
        }}
        className="reject-btn"
      >
        Reject
      </button>
    </div>
  );
};
